export default __webpack_public_path__ + "static/explore_3-8f6d005be636993d438809b8d752ffe4.png";